import React from "react";
import { StoryCard } from "web/react/emo/story-card";
import { useTheEditAnalytics } from "web/react/hooks/use-the-edit-analytics";
import { gettext } from "web/script/modules/django-i18n";
import { StoryCardSerializer } from "web/types/serializers";

interface StoryCardProps extends StoryCardSerializer {
    lazy?: boolean;
    alt?: string;
    index?: number;
}

export function TheEditStoryCard({
    index,
    caption,
    title,
    image_url: imageSrc,
    is_sponsored: isSponsored,
    position: position,
    franchise: franchise,
    url,
    slug,
    lazy = false,
    alt,
    gender,
}: StoryCardProps): React.ReactElement {
    const { containerRef, sendClickEvent } = useTheEditAnalytics({
        label: "story_card",
        editorialSlug: slug,
        isSponsored,
        position,
        franchise,
        gender,
    });

    return (
        <div ref={containerRef} key={`${imageSrc}-${index}`} data-testid="story-card">
            <StoryCard
                customButtonText={gettext("general.read_and_shop")}
                sendClickEvent={sendClickEvent}
                title={title}
                caption={caption}
                url={url}
                image_url={imageSrc}
                is_sponsored={isSponsored}
                position={position}
                franchise={franchise}
                lazy={lazy}
                alt={alt}
            />
        </div>
    );
}
